// Dependencies
import React, { useState, useEffect, useRef } from "react"
import { graphql, Link } from "gatsby"
import PropTypes from "prop-types"
import { useLocation } from "@reach/router"
// Hooks
import useWindowSize from "../hooks/useWindowSize"
import useEventListener from "../hooks/useEventListener"
// Components
import Card from "../components/Card"
import Folder from "../components/Folder"
// import Image from "../components/Image";
import { Image } from "@unpic/react"
import Header from "../components/Header"
import Layout from "../components/Layout"
import Footer from "../components/Footer"
import Stamp from "../components/Stamp"

// Helpers
function useRandomPosition(int) {
  const scale = int || 300
  const position = Math.floor(Math.random() * scale - scale / 2)
  return position
}

const RandomPosition = ({ className, style = {}, children }) => {
  // POSITIONING
  const { width } = useWindowSize()
  const randomPosition = useRef(useRandomPosition())
  const randomRotation = useRef(useRandomPosition(12))
  const translateX = () => (width > 768 ? randomPosition.current : 0)
  const css = {
    ...style,
    transform: `translateX(${translateX()}px)`,
  }

  return (
    <div className={className} style={css}>
      {children(randomPosition.current, randomRotation.current)}
    </div>
  )
}

const FolderWithCards = ({ category, advice }) => {
  // Content
  const relatedAdvice = advice || category.advice

  // UX
  const ref = useRef()
  const [hideInfo, setHideInfo] = useState(false)
  const location = useLocation()

  let flag
  const handleScroll = () => {
    const isMobile = window.innerWidth < 768
    if (ref.current && isMobile) {
      const { top, bottom } = ref.current.getBoundingClientRect()
      if (top < 120 && !flag) {
        flag = true
        setHideInfo(true)
      } else if (top >= 120 && flag) {
        flag = false
        setHideInfo(false)
      }
    }
  }

  useEventListener("scroll", handleScroll)

  useEffect(() => {
    setHideInfo(false)
  }, [location])

  return (
    <div className="layers">
      <div className="bottom">
        <Folder {...category}>
          <section
            className="border"
            style={{
              opacity: !hideInfo ? 1 : 0,
              transition: "opacity 0.2s",
            }}
          >
            <h1>{category.title}</h1>
          </section>
          <section
            style={{
              opacity: !hideInfo ? 1 : 0,
              transition: "opacity 0.2s",
            }}
          >
            <div className="grid">
              <div className="col-4">
                {category.description && (
                  <p className="p2">{category.description.text}</p>
                )}
              </div>
              <div className="col-2">
                <Stamp category={category} randomize />
              </div>
            </div>
          </section>
        </Folder>
      </div>
      <div className="top">
        <div className="cards" ref={ref}>
          {relatedAdvice.map((entry, index) => {
            // const showImage = index % 3 === 2;
            const showImage = true
            return (
              <RandomPosition
                className="folder-card"
                style={{
                  marginBottom: showImage && entry.images ? "30vh" : "10vh",
                }}
                key={`category-advice-${entry.slug}-${index}`}
              >
                {(pos, rotate) => (
                  <>
                    <Card {...entry} isLinked inCategoryFolder />
                    {showImage && entry.images && (
                      <div
                        className={`folder-image ${pos < 0 ? "right" : "left"}`}
                        style={{
                          transform: `rotate(${rotate}deg)`,
                        }}
                      >
                        {/* <Image {...entry.images[0]} /> */}
                        <Image
                          src={entry?.images[0]?.file?.url ?? ""}
                          width={720}
                          layout="constrained"
                        />
                      </div>
                    )}
                  </>
                )}
              </RandomPosition>
            )
          })}
        </div>
        <Footer activeCategory={category} />
      </div>
    </div>
  )
}

export default FolderWithCards
